module.exports = __webpack_public_path__ + "img/sklep-defence-24.1967fce4.svg";